<template>
	<view class="Yi__bezier" :class="{ 'Yi-animate__bezier': animate }"
		:style="{ left: left, top: top, transform: transform_x }" @tap="handleClick">
		<view class="Yi-badge__bezier" :class="{ 'Yi-animate__bezier_y': animate }"
			:style="{ width: width, height: height, borderRadius: height, backgroundColor: backgroundColor, transform: transform_y }">
		</view>
	</view>
</template>

<script>
	export default {
		name: 'Yi-bezier',
		emits: ['click'],
		props: {
			//屏幕宽度[总宽度] px
			windowWidth: {
				type: [Number, String],
				default: 375
			},
			//屏幕高度[总高度] px
			windowHeight: {
				type: [Number, String],
				default: 667
			},
			//小球宽度
			width: {
				type: String,
				default: '30rpx'
			},
			//小球高度
			height: {
				type: String,
				default: '30rpx'
			},
			//动画小球背景颜色
			backgroundColor: {
				type: String,
				default: '#f84a2b'
			},
			//小球 left
			left: {
				type: String,
				default: '0'
			},
			//小球 top
			top: {
				type: String,
				default: '0'
			},
			//括号中为position必传值（根据自身需求可以改位置）
			direction: {
				type: String,
				default: 'down'
			},
			//根据方向传值，终点的坐标点，一般为元素中心位置（根据自身需求可以改位置）
			position: {
				type: Object,
				default () {
					return {
						top: 50,
						bottom: 60,
						left: 75,
						right: 30
					};
				}
			},
			//列表中索引 index
			index: {
				type: Number,
				default: 0
			},
			//自定义参数（父接收）
			params: {
				type: [Number, String],
				default: 0
			}
		},
		data() {
			return {
				time: 0,
				oneTime: 800, //多久触发一次，防止重复点击问题
				animate: false,
				transform_x: '',
				transform_y: '',
			};
		},
		created() {},
		methods: {
			handleClick(e) {
				if (new Date().getTime() - this.time <= this.oneTime) return;
				this.time = new Date().getTime();
				setTimeout(() => {
					this.time = 0;
				}, this.oneTime);
				this.bezierEffect(e);
				this.$emit('click', {
					index: this.index,
					params: this.params //可以发出自定义参数 
				});
			},
			bezierEffect(e) {
				let touch = e.touches[0];
				let diff = {
					x: 0,
					y: 0
				};
				//up-右上，down-右下, bottom-左下，top-左上
				switch (this.direction) {
					case 'up':
						diff.x = this.windowWidth - touch.clientX - this.position.right;
						diff.y = this.position.top - touch.clientY;
						break;
					case 'down':
						diff.x = this.windowWidth - touch.clientX - this.position.right;
						diff.y = this.windowHeight - touch.clientY - this.position.bottom;
						break;
					case 'bottom':
						diff.x = this.position.left - touch.clientX;
						diff.y = this.windowHeight - touch.clientY - this.position.bottom;
						break;
					case 'top':
						diff.x = this.position.left - touch.clientX;
						diff.y = this.position.top - touch.clientY;
						break;
					default:
						break;
				}
				this.animate = true;
				this.transform_x = `translate3d(${diff.x}px,0,0)`;
				this.transform_y = `translate3d(0,${diff.y}px,0) rotate(350deg) scale(0.8)`;
				setTimeout(() => {
					this.animate = false;
					//重置状态
					this.transform_x = 'none';
					this.transform_y = 'none';
				}, this.oneTime-200);
			}
		}
	};
</script>

<style scoped>
	.Yi__bezier {
		position: absolute;
		opacity: 0;
		z-index: 887;
	}

	.Yi-animate__bezier {
		opacity: 1;
		z-index: 990;
		transition: opacity 0.1s, transform cubic-bezier(0, 0, 0, 0) 0.4s;
	}

	.Yi-animate__bezier_y {
		opacity: 1;
		z-index: 990;
		transition: opacity 0.1s, transform cubic-bezier(0.3, -0.2, 1, 0) 0.4s;
	}

	.Yi-badge__bezier {
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 26rpx;
	}
</style>